export class HistoricalDataLogFilter {
  company: string;
  dateFrom: Date;
  dateTo: Date;

  constructor(historicalDataLogFilter) {
    this.company = historicalDataLogFilter.company;
    this.dateFrom = historicalDataLogFilter.dateFrom ? new Date(historicalDataLogFilter.dateFrom) : null;
    this.dateTo = historicalDataLogFilter.dateTo ? new Date(historicalDataLogFilter.dateTo) : null;
  }
}

